export default "__VITE_ASSET__DwLa$yv9__"